import { ExportDropdown } from "@components/common/export/export-dropdown";
import {
  activeMembersSelector,
  fetchingActiveMembersFlagsSelector,
} from "@store/active-members/active-members-selector";
import { selectedSdbCompanyNameSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { downloadMembersData, ExportFormat } from "@utils/file-data-export";
import { TableType } from "@utils/track-event/track-event-list";

/** Dropdown to export the active members in the file format selected by the user */
export function ActiveMembersExport(): JSX.Element {
  const activeMembers = useAppSelector(activeMembersSelector);
  const companyName = useAppSelector(selectedSdbCompanyNameSelector);
  const { status } = useAppSelector(fetchingActiveMembersFlagsSelector);

  async function exportHandler(format: ExportFormat): Promise<number> {
    return await downloadMembersData({
      fileName: `${companyName}-Active Members List`,
      members: activeMembers,
      subjectType: "activeMembers",
      format,
    });
  };

  return (
    <ExportDropdown
      trackingProps={{
        dataType: TableType.activeMembers,
        numberOfEntities: activeMembers.length,
        areEntitiesSelected: false,
      }}
      exportHandler={exportHandler}
      toastMessage={{
        success: "Successfully exported active members.",
        error: "Cannot export active members. Please try again.",
      }}
      buttonTooltipText="Export active members"
      shouldShowSkeleton={status === "pending"}
      buttonType="standard"
    />
  );
}
